<template>
	<div class="page-download">
		<img v-bind:src="funreport.pic.replace('animal', 'animalHD').replace('../', './')">
		<router-link :to="'/funreport?stay=1'" class="btn">返回报告页</router-link>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import router from '../router.js'

export default {
	name: 'download',
	computed: mapState({
		funreport: state => state.funreport
	}),
	mounted() {
		document.querySelector('.page-download').style.minHeight = window.screen.availHeight + 'px';

			wx.ready(function() {
				wx.hideMenuItems({
				    menuList: [
				    'menuItem:share:qq',
				    'menuItem:share:timeline',
				    "menuItem:share:appMessage",
				    'menuItem:share:weiboApp',
				    'menuItem:share:QZone',
				    "menuItem:openWithSafari",
				    "menuItem:copyUrl"
				    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
				});
			});
	}
}
</script>

<style lang="scss" scoped>
$font-size-base:32; // Base on 320px;
@function topx($rem) {
  @return $rem/$font-size-base;
}

.page-download {
	width: 100%;
	text-align: center;
	img {
		max-width: 100%;
	}
	.btn {
		display: inline-block;
		height: topx(60rem * 0.5);
		padding: 0 topx(12rem * 0.5);
		margin-top: topx(20rem * 0.5);
		font-size: topx(24rem * 0.5);
		color: #81600e;
		background: #edc96f;
		line-height: topx(62rem * 0.5);
		border-radius: topx(10rem * 0.5);
		border: topx(3rem * 0.5) solid #e6ae24;
	}
}
</style>



// WEBPACK FOOTER //
// download.vue?dde03b78